type Props = {
  color: string;
};

export default function LeftArrowIcon(props: Props) {
  return (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.46167 0.845952L1.53857 7.76904L8.46166 14.6921"
        stroke={props.color}
        strokeWidth="2"
      />
    </svg>
  );
}
